import actions from "./actions";

export default {
  actions,
  state: {
    costom: {
      shape: "如意",
      style: "如意五福雙獅",
      text: { templeName: "", godName: "", gift: "", respect: "" },
      size: { unit: "cm", length: "", weight: "", way: "" },
      amount: 1,
      price: "",
      total: "",
      imageUrl: "",
      accessory: 1
    },
    componentCode: "A",
    canvasDataUrl: "",
    way: [
      { wayCode: "A", wayName: "精緻平裝純金金牌" },
      { wayCode: "B", wayName: "立體浮雕純金金牌" },
      { wayCode: "C", wayName: "立體浮雕鐳射紅字純金金牌" },
      { wayCode: "D", wayName: "週歲鎖片" },
      { wayCode: "E", wayName: "立體浮雕純金獎牌" },
      { wayCode: "F", wayName: "手工精雕雙面扇" },
      { wayCode: "G", wayName: "手工紋飾單面扇" },
      { wayCode: "H", wayName: "傳統金牌雷雕字體" }
    ],
    unit: [
      { unitEnglish: "cm", unitChinese: "公分" },
      { unitEnglish: "tin", unitChinese: "台吋" }
    ]
  },
  mutations: {
    updateCostom: (state, payload) => {
      let key = payload.key;
      state.costom[key] = payload.content;
    },
    emptyCustomInfo: state => {
      state.costom = {
        shape: "如意",
        style: "如意五福雙獅",
        text: { templeName: "", godName: "", gift: "", respect: "" },
        size: { unit: "cm", length: "", weight: "", way: "" },
        amount: 1,
        price: "",
        total: "",
        imageUrl: "",
        accessory: 1
      };
      state.componentCode = "A";
    },
    updateComponentCode: (state, payload) => {
      state.componentCode = payload;
    },
    updataCanvasDataUrl: (state, payload) => {
      state.canvasDataUrl = payload;
    },
    updataImageUrl: (state, payload) => {
      state.costom.imageUrl = payload;
    }
  },
  getters: {
    currentCustom: state => {
      return state.costom;
    },
    getCutomText: state => {
      return state.costom.text;
    },
    getCutomTempleName: state => {
      return state.costom.text.templeName;
    },
    getCutomGodName: state => {
      return state.costom.text.godName;
    },
    getCutomGift: state => {
      return state.costom.text.gift;
    },
    getCutomRespect: state => {
      return state.costom.text.respect;
    },
    getComponentCode: state => {
      return state.componentCode;
    },
    getImageUrl: state => {
      return state.costom.imageUrl;
    },
    getCanvasDataUrl: state => {
      return state.canvasDataUrl;
    },
    getCustomGlobalUrl: (state, getters, rootState, rootGetters) => {
      return rootGetters.getGlobalUrl;
    },
    getTransformWay: state => wayCode => {
      let res = state.way.find(item => item.wayCode === wayCode);
      return res ? res.wayName : "查無此金牌";
    },
    getTransformUnit: state => unitEnglish => {
      return state.unit.find(item => item.unitEnglish === unitEnglish)
        .unitChinese;
    },
    isMedalsLabelDisplay(state) {
      // 方框形式的 Label 表現方式不一樣，例如祝賀詞與名稱 vs 宮廟名
      return ["AA", "AB", "AC"].includes(state.componentCode);
    },
    medalsLabelDisplayStyle() {
      return ["週歲生日獎牌", "結婚 祝壽 記念金牌", "週歲鎖片"];
    },
    getWayOptions({ way }) {
      return way;
    }
  }
};
